import { Grid, Card, CardContent, Typography, Avatar, Chip, IconButton, Box } from "@mui/material";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import DescriptionIcon from "@mui/icons-material/Description";
import ImageIcon from "@mui/icons-material/Image";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import { DeleteForever } from "@mui/icons-material";

const getIcon = (documentType) => {
    switch (documentType) {
        case 1: // PDF
            return <PictureAsPdfIcon fontSize="large" />
        case 2: // Text
            return <DescriptionIcon fontSize="large" />
        case 3: // Word
            return <ImageIcon fontSize="large" />
        case 4: // Excel
            return <DescriptionIcon sx={{ color: 'green' }} />
        case 5: // Image
            return <ImageIcon color="primary" />
        case 6: // Markdown
            return <DescriptionIcon sx={{ color: '#6f42c1' }} />
        case 7: // HTML
            return <DescriptionIcon sx={{ color: '#e34c26' }} />
        case 8: // CSV
            return <DescriptionIcon sx={{ color: 'green' }} />
        default:
            return <InsertDriveFileIcon fontSize="large" />
    }
}

const getDocumentTypeName = (documentType) => {
    switch (documentType) {
        case 1:
            return "PDF"
        case 2:
            return "Documento"
        case 3:
            return "Imagem"
        case 4:
            return "Excel"
        case 5:
            return "Image"
        case 6:
            return "Markdown"
        case 7:
            return "HTML"
        case 8:
            return "CSV"
        default:
            return "Desconhecido"
    }
}

const getStatusColor = (status) => {
    switch (status) {
        case 1:
            return "#1976d2"; // Azul

        case 2:
            return "#1976d2"; // Azul

        case 3:
            return "#2e7d32"; // Verde

        case 4:
            return "#d32f2f"; // Vermelho

        case 5:
            return "#1976d2"; // Azul

        case 6:
            return "#d32f2f"; // Vermelho

        case 7:
            return "#1976d2"; // Azul

        case 8:
            return "#d32f2f"; // Azul

        default:
            return "#757575"; // Cinza
    }
}

const getStatusLabel = (status) => {
    switch (status) {
        case 1:
            return "Pendente";

        case 2:
            return "Processando";

        case 3:
            return "Processado";

        case 4:
            return "Falhou";

        case 5:
            return "Parcialmente processado";

        case 6:
            return "Erro";

        case 7:
            return "A ser deletado";

        case 8:
            return "Deletado";

        default:
            return "Desconhecido";
    }
}

const getStatusBackgroundColor = (status) => {
    switch (status) {
        case 1:
            return "#e3f2fd";

        case 2:
            return "#e3f2fd";

        case 5:
            return "#e3f2fd";

        case 3:
            return "#e8f5e9";

        case 4:
            return "#ffebee";

        case 6:
            return "#ffebee";

        default:
            return "#f5f5f5";
    }
}

export const FileCard = ({ file, onOpenFile, onDelete, intl }) => {

    return (
        <>
            <Grid item xs={12} sm={6} md={4} lg={3} xl={2.4} key={file.id}>
                <Card
                    onClick={onOpenFile}
                    sx={{
                        position: 'relative',
                        border: "1px solid #ddd",
                        borderRadius: "12px",
                        padding: "12px",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        textAlign: "center",
                        cursor: "pointer",
                        borderLeft: `4px solid ${getStatusColor(file.status)}`,
                        borderRadius: "12px",
                    }}
                >
                    <Box
                        sx={{
                            position: "absolute",
                            top: 6,
                            right: 6,
                            display: "flex",
                            gap: 0.5,
                            zIndex: 2,
                        }}
                    >
                        <IconButton
                            size="small"
                            color="error"
                            onClick={(e) => {
                                e.stopPropagation()
                                onDelete()
                            }}
                        >
                            <DeleteForever fontSize="small" />
                        </IconButton>
                    </Box>
                    <Avatar sx={{ width: 56, height: 56, mb: 1 }}>
                        {getIcon(file.documenttype)}
                    </Avatar>

                    <CardContent sx={{ p: 0, pb: '0 !important', width: '100%' }}>
                        <Typography
                            variant="body1"
                            noWrap
                            sx={{
                                fontWeight: 500,
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                width: "100%",
                            }}
                        >
                            {file.filename}
                        </Typography>

                        <Typography variant="body2" color="text.secondary">
                            {getDocumentTypeName(file.documenttype)}
                        </Typography>
                        <Chip
                            label={getStatusLabel(file.status)}
                            size="small"
                            sx={{
                                mt: 1,
                                bgcolor: getStatusBackgroundColor(file.status),
                                color: getStatusColor(file.status),
                                fontWeight: 600,
                            }}
                        />
                    </CardContent>
                </Card>
            </Grid>
        </>
    )
}

export default FileCard